module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md m-b-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v(" Consulta de Reboque ")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "text-right text-left-xs"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-md ",
    attrs: {
      "to": {
        name: 'logout'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Sair\n                  ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "input-group main-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.busca),
      expression: "filtros.busca"
    }],
    staticClass: "input-sm form-control",
    attrs: {
      "type": "text",
      "placeholder": "DIGITE A PLACA DO REBOQUE",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.filtros.busca)
    },
    on: {
      "keyup": _vm.pesquisar,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "busca", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v("Carregando...")]) : _c('div', {
    staticClass: "table-responsive main-container"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredData && _vm.filteredData.length),
      expression: "filteredData && filteredData.length"
    }],
    staticClass: "table table-hover table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Identificação")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Ativo")])])]), _vm._v(" "), _c('tbody', [_vm._l(([1, 2, 3]), function(i) {
    return (_vm.isLoading) ? _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "20px"
      }
    })], 1), _vm._v(" "), _c('td', [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data), function(reboque) {
    return _c('tr', [_c('td', [_c('span', {
      staticClass: "text-cap custom-link"
    }, [_vm._v(_vm._s(reboque.id))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "text-cap custom-link"
    }, [_vm._v(_vm._s(reboque.identificacao))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "text-cap custom-link"
    }, [_vm._v(_vm._s(reboque.placa))])]), _vm._v(" "), _c('td', [(reboque.ativo) ? _c('span', {
      staticClass: "text-cap custom-link"
    }, [_vm._v("Ativo")]) : _c('span', {
      staticClass: "text-cap custom-link text-danger"
    }, [_vm._v("Inativo")])])])
  })], 2)]), _vm._v(" "), (_vm.filtros.busca && _vm.filteredData && !_vm.filteredData.length) ? _c('span', {
    staticClass: "text-center"
  }, [_vm._v("Nenhum registro encontrado")]) : _vm._e()])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-096ce1df","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/configuracoes/reboque/components/ConsultaReboque.vue
// module id = 1481
// module chunks = 17